import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card export-wrap" }
const _hoisted_2 = { class: "row align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "col-sm-10" }, [
  /*#__PURE__*/_createVNode("h1", { class: "title mb-2" }, "All Business Mail List"),
  /*#__PURE__*/_createVNode("p", { class: "mb-sm-0" }, [
    /*#__PURE__*/_createVNode("small", null, "Business Mail.")
  ])
], -1)
const _hoisted_4 = { class: "col-sm-2" }
const _hoisted_5 = { class: "text-sm-right" }
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "fa fa-plus mr-1" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Create ")
const _hoisted_8 = { class: "card p-0" }
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = { class: "table table-shadowed table-relative mb-0" }
const _hoisted_11 = /*#__PURE__*/_createVNode("thead", { class: "table-primary" }, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", { scope: "col" }, " S.N. "),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Title"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Create"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Action")
  ])
], -1)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "file-actions position-relative" }
const _hoisted_14 = /*#__PURE__*/_createVNode("i", { class: "fa fa-eye" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("i", { class: "fa fa-pen" }, null, -1)
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { colspan: "5" }
const _hoisted_18 = {
  key: 2,
  class: "table-loader chat-load"
}
const _hoisted_19 = { class: "modal-wrap default-modal" }
const _hoisted_20 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "mailTemplate",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_21 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_22 = { class: "modal-content" }
const _hoisted_23 = { class: "card p-0 modal-newsletter" }
const _hoisted_24 = { class: "table-responsive" }
const _hoisted_25 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_EmptyData = _resolveComponent("EmptyData")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("a", {
              href: "javascript:void(0)",
              type: "button",
              class: "btn default-btn d-inline-block",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.createBusinessMailTemplate && _ctx.createBusinessMailTemplate(...args)))
            }, [
              _hoisted_6,
              _hoisted_7
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_8, [
      _createVNode("div", _hoisted_9, [
        _createVNode("table", _hoisted_10, [
          _hoisted_11,
          (_ctx.state.mailTemplateList.length)
            ? (_openBlock(), _createBlock("tbody", _hoisted_12, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.mailTemplateList, (template, templateIndex) => {
                  return (_openBlock(), _createBlock("tr", { key: templateIndex }, [
                    _createVNode("td", null, _toDisplayString(templateIndex+1), 1),
                    _createVNode("td", null, _toDisplayString(template.title), 1),
                    _createVNode("td", null, _toDisplayString(template.created_at), 1),
                    _createVNode("td", null, [
                      _createVNode("div", _hoisted_13, [
                        _createVNode("a", {
                          href: "javascript:void(0)",
                          onClick: ($event: any) => (_ctx.showMailTemplate(template)),
                          title: "Preview"
                        }, [
                          _hoisted_14
                        ], 8, ["onClick"]),
                        _createVNode(_component_router_link, {
                          class: "edit-class",
                          title: "Edit",
                          to: {
                          name: 'edit-business-mail-template',
                          params: { tempId: template.id },
                        }
                        }, {
                          default: _withCtx(() => [
                            _hoisted_15
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ])
                    ])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createBlock("tfoot", _hoisted_16, [
                _createVNode("tr", null, [
                  _createVNode("td", _hoisted_17, [
                    _createVNode(_component_EmptyData, {
                      title: _ctx.state.data.title,
                      heading: _ctx.state.data.heading
                    }, null, 8, ["title", "heading"])
                  ])
                ])
              ])),
          (_ctx.state.ui.isPostLoading.getUserActivityList)
            ? (_openBlock(), _createBlock("div", _hoisted_18, [
                _createVNode("img", {
                  src: 
                _ctx.state.data.imageBaseUrl
                  ? `${_ctx.state.data.imageBaseUrl}img/chat-loading.gif`
                  : 'img/chat-loading.gif'
              ,
                  alt: ""
                }, null, 8, ["src"])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode("div", _hoisted_19, [
      _createVNode("div", _hoisted_20, [
        _createVNode("div", _hoisted_21, [
          _createVNode("div", _hoisted_22, [
            _createVNode("div", _hoisted_23, [
              _createVNode("div", _hoisted_24, [
                _createVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.hideMailTemplate && _ctx.hideMailTemplate(...args))),
                  "aria-label": "Close"
                }, [
                  _hoisted_25
                ]),
                _createVNode("div", {
                  innerHTML: _ctx.state.message
                }, null, 8, ["innerHTML"])
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.state.data.showSuccesCustomModal)
      ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
          key: 0,
          onClose: _ctx.closeSuccessCustomModal,
          showModal: _ctx.state.data.showSuccesCustomModal,
          titleMessage: _ctx.state.data.successMessage
        }, null, 8, ["onClose", "showModal", "titleMessage"]))
      : _createCommentVNode("", true)
  ]))
}